import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import TableStateCard from '../components/TableStateCard';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { validateSession } from '../utils/functions';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';

var config = process.env;

// IVA al que factura la cadetería. Sólo se usa para SUGERIR el total al tipear el neto;
// el total que se guarda es siempre el que queda en el input (redondeos del proveedor).
const IVA = 0.22;

class TableShippingProvidersComponent extends Component {

    constructor() {
        super();
        this.state = {
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'name',
            sortDir: 'asc',
            data: [],
            loaded: false,
            role: 0,
            // ABM de cadeterías (revisión de envíos): hasta acá la tabla era de sólo lectura
            // y las cadeterías se cargaban a mano en la DB.
            modalAbierto: false,
            editandoId: null,     // null = alta
            formNombre: '',
            formTelefono: '',
            formCosto: '',
            formDefault: false,
            guardando: false,
            formError: '',
            // Tarifas por zona: la cadetería factura por zona (las 11 zonas Flex de ML),
            // el costo plano de arriba queda como fallback para envíos sin zona.
            tarifasProvider: null,   // {providerId, name} del modal abierto, o null
            zonas: [],
            tarifas: {},             // zoneId -> { netCost, totalCost } (strings de los inputs)
            tarifasIniciales: {},    // snapshot al cargar: para confirmar antes de borrar
            tarifasCargando: false,
            tarifasGuardando: false,
            tarifasError: '',
        };
    }

    async componentDidMount() {
        this.fetchData();
        let role = await validateSession();
        this.setState({ role: role });
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        const query = buildPaginationQuery({ page, limit, search, sortBy, sortDir });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}provider/shipping?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true
                });
            }
        });
    }

    // ── ABM de cadeterías ────────────────────────────────────────────────────
    abrirAlta = () => this.setState({
        modalAbierto: true, editandoId: null,
        formNombre: '', formTelefono: '', formCosto: '', formDefault: false, formError: '',
    });

    abrirEdicion = (item) => this.setState({
        modalAbierto: true, editandoId: item.providerId,
        formNombre: item.name || '',
        formTelefono: item.phone || '',
        formCosto: item.cost != null ? String(item.cost) : '',
        formDefault: item.isDefaultProvider == 1,
        formError: '',
    });

    cerrarModal = () => this.setState({ modalAbierto: false, formError: '', guardando: false });

    guardarCadeteria = () => {
        const { editandoId, formNombre, formTelefono, formCosto, formDefault } = this.state;
        const nombre = (formNombre || '').trim();
        if (!nombre) {
            this.setState({ formError: 'El nombre es obligatorio.' });
            return;
        }
        // Entero: la columna del backend es INT y un decimal se redondearía en silencio
        // (se tipea 202.52, se guarda 203 y el refresh muestra otra cosa).
        if (formCosto !== '' && !/^\d+$/.test(formCosto)) {
            this.setState({ formError: 'El costo plano tiene que ser un importe entero (ej: 250). El tarifario por zona sí acepta decimales.' });
            return;
        }
        // Cada envío se numera: una respuesta que llega tarde ya no corresponde a lo que hay
        // en pantalla (mismo criterio que el ABM de proveedores de mercadería).
        this.envioActual = (this.envioActual || 0) + 1;
        const envio = this.envioActual;
        const vigente = () => this.envioActual === envio;
        this.setState({ guardando: true, formError: '' });

        const esAlta = editandoId == null;
        const request = {
            method: esAlta ? 'POST' : 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: nombre,
                phone: formTelefono || '',
                cost: formCosto === '' ? null : Number(formCosto),
                isDefaultProvider: !!formDefault,
            }),
        };
        const url = config.REACT_APP_BASE_URL + config.REACT_APP_VERSION
            + 'provider/shipping' + (esAlta ? '' : `/${editandoId}`);

        fetch(url, request)
            .then((results) => results.json())
            .then((data) => {
                if (!vigente()) return;
                if (data.error == 1002) {
                    alert(data.message);
                    window.location.href = localStorage.getItem('homePageURL');
                    return;
                }
                if (data.error > 0) {
                    this.setState({ guardando: false, formError: (data.data && data.data.message) || data.message });
                    return;
                }
                this.setState({ modalAbierto: false, guardando: false });
                this.fetchData({ showLoader: false });
            })
            .catch(() => {
                if (!vigente()) return;
                this.setState({ guardando: false, formError: 'No se pudo guardar. Reintentá.' });
            });
    }

    // ── Tarifas por zona ─────────────────────────────────────────────────────
    abrirTarifas = (item) => {
        // Numerador anti-respuesta-tardía TAMBIÉN acá (hallazgo del code review): sin él,
        // abrir A → cancelar → abrir B podía pintar (y después GUARDAR) el tarifario de A
        // sobre B si la respuesta de A llegaba después.
        this.envioCargaTarifas = (this.envioCargaTarifas || 0) + 1;
        const envio = this.envioCargaTarifas;
        const vigente = () => this.envioCargaTarifas === envio && this.state.tarifasProvider
            && this.state.tarifasProvider.providerId === item.providerId;

        this.setState({
            tarifasProvider: { providerId: item.providerId, name: item.name },
            zonas: [], tarifas: {}, tarifasIniciales: {}, tarifasCargando: true, tarifasError: '',
        });
        const request = {
            method: 'GET',
            headers: { 'access-token': localStorage.getItem('token'), 'Content-Type': 'application/json' },
        };
        Promise.all([
            fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'provider/shipping/zones', request).then((r) => r.json()),
            fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `provider/shipping/${item.providerId}/rates`, request).then((r) => r.json()),
        ])
            .then(([zonasData, ratesData]) => {
                if (!vigente()) return;
                if (zonasData.error == 1002 || ratesData.error == 1002) {
                    alert(zonasData.message || ratesData.message);
                    window.location.href = localStorage.getItem('homePageURL');
                    return;
                }
                if (zonasData.error > 0 || ratesData.error > 0) {
                    const mensaje = (zonasData.data && zonasData.data.message) || zonasData.message
                        || (ratesData.data && ratesData.data.message) || ratesData.message;
                    this.setState({ tarifasCargando: false, tarifasError: mensaje });
                    return;
                }
                const tarifas = {};
                (ratesData.data || []).forEach((rate) => {
                    tarifas[rate.zoneId] = {
                        netCost: rate.netCost != null ? String(Number(rate.netCost)) : '',
                        totalCost: rate.totalCost != null ? String(Number(rate.totalCost)) : '',
                    };
                });
                this.setState({
                    zonas: zonasData.data || [],
                    tarifas,
                    // Snapshot de qué zonas TENÍAN tarifa al cargar: el guardado confirma
                    // antes de borrar cualquiera de éstas (el contrato es destructivo).
                    tarifasIniciales: { ...tarifas },
                    tarifasCargando: false,
                });
            })
            .catch(() => {
                if (!vigente()) return;
                this.setState({ tarifasCargando: false, tarifasError: 'No se pudieron cargar las tarifas. Reintentá.' });
            });
    }

    cerrarTarifas = () => {
        // Invalida cualquier carga en vuelo: su respuesta tardía ya no corresponde a nada.
        this.envioCargaTarifas = (this.envioCargaTarifas || 0) + 1;
        this.setState({ tarifasProvider: null, tarifasError: '', tarifasGuardando: false, tarifasCargando: false });
    }

    cambiarTarifa = (zoneId, campo, valor) => {
        this.setState((prev) => ({
            tarifas: {
                ...prev.tarifas,
                [zoneId]: { netCost: '', totalCost: '', ...prev.tarifas[zoneId], [campo]: valor },
            },
        }));
    }

    // Al salir del neto con el total vacío se sugiere neto + IVA. Sugerencia, no imposición:
    // el proveedor redondea ($139 + IVA lo factura $170, no $169.58) y el total manda.
    sugerirTotal = (zoneId) => {
        const fila = this.state.tarifas[zoneId];
        if (!fila || fila.totalCost !== '' || fila.netCost === '' || !/^\d+(\.\d{1,2})?$/.test(fila.netCost)) {
            return;
        }
        const total = (Number(fila.netCost) * (1 + IVA)).toFixed(2);
        this.cambiarTarifa(zoneId, 'totalCost', total);
    }

    guardarTarifas = () => {
        const { tarifasProvider, tarifas } = this.state;
        // Con la grilla vacía (zonas que no cargaron) un PUT mandaría rates: [] y el
        // backend borraría el tarifario ENTERO. No se manda nunca en ese estado
        // (hallazgo del code review; el backend además ahora lo rechaza).
        if (this.state.zonas.length === 0) {
            this.setState({ tarifasError: 'Las zonas no cargaron: cerrá y volvé a abrir el modal antes de guardar.' });
            return;
        }
        const rates = [];
        for (const zona of this.state.zonas) {
            const fila = tarifas[zona.zoneId];
            const total = fila ? String(fila.totalCost).trim() : '';
            const neto = fila ? String(fila.netCost).trim() : '';
            if (total === '' && neto === '') {
                continue; // sin tarifa para esa zona: se borra del tarifario
            }
            if (total === '') {
                this.setState({ tarifasError: `A la ${zona.label} le falta el total (el neto solo no alcanza).` });
                return;
            }
            if (!/^\d+(\.\d{1,2})?$/.test(total) || (neto !== '' && !/^\d+(\.\d{1,2})?$/.test(neto))) {
                this.setState({ tarifasError: `La tarifa de la ${zona.label} tiene que ser un importe válido (ej: 203 o 202.52).` });
                return;
            }
            rates.push({ zoneId: zona.zoneId, netCost: neto === '' ? null : neto, totalCost: total });
        }

        // El contrato es destructivo (zona no enviada = se borra): si el guardado va a
        // ELIMINAR tarifas que existían al abrir el modal, se confirma nombrándolas.
        const enviadas = new Set(rates.map((rate) => rate.zoneId));
        const aBorrar = this.state.zonas
            .filter((zona) => {
                const inicial = this.state.tarifasIniciales[zona.zoneId];
                return inicial && inicial.totalCost !== '' && !enviadas.has(zona.zoneId);
            })
            .map((zona) => zona.label);
        if (aBorrar.length > 0 && !window.confirm(`Vas a QUITAR la tarifa de: ${aBorrar.join(', ')}. Esas zonas van a caer al costo plano. ¿Confirmás?`)) {
            return;
        }

        this.envioTarifas = (this.envioTarifas || 0) + 1;
        const envio = this.envioTarifas;
        const vigente = () => this.envioTarifas === envio;
        this.setState({ tarifasGuardando: true, tarifasError: '' });

        const request = {
            method: 'PUT',
            headers: { 'access-token': localStorage.getItem('token'), 'Content-Type': 'application/json' },
            body: JSON.stringify({ rates }),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `provider/shipping/${tarifasProvider.providerId}/rates`, request)
            .then((results) => results.json())
            .then((data) => {
                if (!vigente()) return;
                if (data.error == 1002) {
                    alert(data.message);
                    window.location.href = localStorage.getItem('homePageURL');
                    return;
                }
                if (data.error > 0) {
                    this.setState({ tarifasGuardando: false, tarifasError: (data.data && data.data.message) || data.message });
                    return;
                }
                this.setState({ tarifasProvider: null, tarifasGuardando: false });
            })
            .catch(() => {
                if (!vigente()) return;
                this.setState({ tarifasGuardando: false, tarifasError: 'No se pudo guardar. Reintentá.' });
            });
    }

    renderModalTarifas = () => {
        const { tarifasProvider } = this.state;
        if (!tarifasProvider) return null;
        const puedeEditar = this.state.role == 1;
        return (
            <div id="modal-tarifas" className="modal" role="dialog" style={{ display: 'block', background: 'rgba(0,0,0,.4)' }}>
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Tarifas por zona — {tarifasProvider.name}</h4>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                            {this.state.tarifasCargando ? <div>Cargando…</div> : (
                                <div>
                                    <small className="text-muted d-block mb-2">
                                        Las zonas son las de Envíos Flex de MercadoLibre (1-7 Montevideo, 8-11 Canelones).
                                        Una zona sin tarifa usa el costo plano de la cadetería. "Ref. ML" es lo que ML
                                        cobra/bonifica sobre esa zona: si tu tarifa la supera, ese envío pierde plata.
                                    </small>
                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Zona</th>
                                                <th>Departamento</th>
                                                <th style={{ textAlign: 'right' }}>Ref. ML</th>
                                                <th style={{ width: '20%' }}>Neto (sin IVA)</th>
                                                <th style={{ width: '20%' }}>Total (con IVA)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.zonas.map((zona) => {
                                                const fila = this.state.tarifas[zona.zoneId] || { netCost: '', totalCost: '' };
                                                const total = Number(fila.totalCost);
                                                const pierde = fila.totalCost !== '' && Number.isFinite(total)
                                                    && zona.mlPrice != null && total > Number(zona.mlPrice);
                                                return (
                                                    <tr key={zona.zoneId}>
                                                        <td>{zona.label}</td>
                                                        <td>{zona.department}</td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            {zona.mlPrice != null ? `$ ${Number(zona.mlPrice)}` : '—'}
                                                        </td>
                                                        <td>
                                                            <input type="text" className="form-control form-control-sm" inputMode="decimal"
                                                                name={`neto-${zona.zoneId}`}
                                                                value={fila.netCost} disabled={!puedeEditar}
                                                                onChange={(e) => this.cambiarTarifa(zona.zoneId, 'netCost', e.target.value)}
                                                                onBlur={() => this.sugerirTotal(zona.zoneId)} />
                                                        </td>
                                                        <td>
                                                            <input type="text" inputMode="decimal"
                                                                name={`total-${zona.zoneId}`}
                                                                className={`form-control form-control-sm ${pierde ? 'border-warning' : ''}`}
                                                                title={pierde ? 'La tarifa supera lo que ML paga por esta zona: ese envío pierde plata.' : ''}
                                                                value={fila.totalCost} disabled={!puedeEditar}
                                                                onChange={(e) => this.cambiarTarifa(zona.zoneId, 'totalCost', e.target.value)} />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                            {this.state.tarifasError
                                ? <div className="alert alert-danger py-2 mb-0">{this.state.tarifasError}</div>
                                : null}
                        </div>
                        <div className="modal-footer">
                            {puedeEditar ? (
                                <button type="button" className="btn btn-accent"
                                    disabled={this.state.tarifasGuardando || this.state.tarifasCargando || this.state.zonas.length === 0}
                                    onClick={this.guardarTarifas}>
                                    {this.state.tarifasGuardando ? 'Guardando…' : 'Guardar tarifas'}
                                </button>
                            ) : null}
                            <button type="button" className="btn btn-outline-secondary" onClick={this.cerrarTarifas}>
                                {puedeEditar ? 'Cancelar' : 'Cerrar'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderModal = () => {
        if (!this.state.modalAbierto) return null;
        const esAlta = this.state.editandoId == null;
        return (
            <div id="modal-cadeteria" className="modal" role="dialog" style={{ display: 'block', background: 'rgba(0,0,0,.4)' }}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">{esAlta ? 'Nueva cadetería' : 'Editar cadetería'}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nombre</label>
                                <input type="text" name="shippingProviderName" className="form-control" maxLength={45}
                                    value={this.state.formNombre} autoFocus
                                    onChange={(e) => this.setState({ formNombre: e.target.value })} />
                                <small className="text-muted">Máximo 45 caracteres.</small>
                            </div>
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input type="text" name="shippingProviderPhone" className="form-control" maxLength={45}
                                    value={this.state.formTelefono}
                                    onChange={(e) => this.setState({ formTelefono: e.target.value })} />
                            </div>
                            <div className="form-group">
                                <label>Costo plano (fallback)</label>
                                <input type="text" name="shippingProviderCost" className="form-control" inputMode="decimal"
                                    value={this.state.formCosto}
                                    onChange={(e) => this.setState({ formCosto: e.target.value })} />
                                <small className="text-muted">
                                    Se usa sólo cuando el envío no cae en ninguna zona con tarifa. El tarifario
                                    real se carga por zona con el botón "Tarifas".
                                </small>
                            </div>
                            <div className="form-group">
                                <label className="d-flex align-items-center" style={{ gap: '8px' }}>
                                    <input type="checkbox" name="shippingProviderDefault"
                                        checked={this.state.formDefault}
                                        onChange={(e) => this.setState({ formDefault: e.target.checked })} />
                                    <span>Cadetería por defecto</span>
                                </label>
                                <small className="text-muted">
                                    La que se asigna a los envíos de la tienda web. Marcar ésta desmarca la anterior.
                                </small>
                            </div>
                            {this.state.formError
                                ? <div className="alert alert-danger py-2 mb-0">{this.state.formError}</div>
                                : null}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-accent" disabled={this.state.guardando}
                                onClick={this.guardarCadeteria}>
                                {this.state.guardando ? 'Guardando…' : (esAlta ? 'Crear cadetería' : 'Guardar')}
                            </button>
                            <button type="button" className="btn btn-outline-secondary" onClick={this.cerrarModal}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty"><td colSpan="6" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                </td></tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    drawRow = (item, index) => {
        return (
            <tr role="row" className="odd" key={item.providerId} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{item.providerId}</td>
                <td>{item.name}</td>
                <td>{item.cost}</td>
                <td>{item.phone}</td>
                <td>{item.isDefaultProvider == 1 ? 'Sí' : 'No'}</td>
                <td style={{ textAlign: 'right' }}>
                    {/* El operador (rol 2) también VE el tarifario (arma envíos y necesita
                        saber cuánto sale cada zona); el modal ya es read-only para él y el
                        backend da los GET a [1,2]. Editar sigue siendo sólo de admin. */}
                    <button type="button" className="btn btn-sm btn-white" style={{ fontSize: '12px' }}
                        onClick={() => this.abrirTarifas(item)}>{this.state.role == 1 ? 'Tarifas' : 'Ver tarifas'}</button>
                    {this.state.role == 1 ? (
                        <button type="button" className="btn btn-sm btn-white ml-1" style={{ fontSize: '12px' }}
                            onClick={() => this.abrirEdicion(item)}>Editar</button>
                    ) : null}
                </td>
            </tr>
        );
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        const searchActive = hasActiveSearch(this.state.searchInput, this.state.search);

        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        // El botón de alta va TAMBIÉN en el estado vacío: sin cadeterías cargadas no habría
        // forma de crear la primera (misma trampa que el ABM de proveedores en staging).
        const botonAlta = this.state.role == 1 ? (
            <button type="button" className="btn btn-sm btn-accent mb-3" onClick={this.abrirAlta}>
                + Crear cadetería
            </button>
        ) : null;

        if (this.state.totalItems === 0 && !searchActive) {
            return (
                <div>
                    {botonAlta}
                    <TableStateCard
                        icon="local_shipping"
                        title="Todavia no hay cadeterias para mostrar"
                        message="Crea la primera cadeteria y cargale su tarifario por zona con el boton Tarifas."
                    />
                    {this.renderModal()}
                </div>
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                {botonAlta}
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('providerId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>ID</th>
                            <th {...this.sortableHeader('name')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '25%' }}>Nombre</th>
                            <th {...this.sortableHeader('cost')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }} title="Se usa sólo para envíos sin zona con tarifa">Costo plano</th>
                            <th {...this.sortableHeader('phone')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '25%' }}>Teléfono</th>
                            <th {...this.sortableHeader('isDefaultProvider')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Por defecto</th>
                            <th className="sorting_disabled" rowSpan="1" colSpan="1" style={{ width: '15%' }}></th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
                {this.renderModal()}
                {this.renderModalTarifas()}
            </div>
        );
    }
}

export default TableShippingProvidersComponent;
